import { Injectable } from "@angular/core";
import { Adapter, LoadScripts, StoreAdapter, Style } from "web-adapter-js";
interface ScriptsType {
  name: string;
  src: string;
}

interface StylesType {
  name: string;
  src: string;
  type: string;
}
@Injectable({ providedIn: "root" })
export class WebAdapterService {
  private initAdapter = new Adapter();
  private scriptLoader = new LoadScripts();

  private stylesLoader = new Style();
  private adapterRoot = StoreAdapter.root;

  constructor() {}

  public loadStyles(styles: StylesType[]): void {
    this.stylesLoader.allRemoveStyles();
    this.stylesLoader.loadCdn([...styles]);
  }

  public dispatch<T>(data: T): void {
    this.adapterRoot.dispatch(data);
  }

  public initElements(scripts: ScriptsType[]): void {
    this.initAdapter.init();
    this.scriptLoader.import(scripts);
  }

  public destroyElements(name: string[]): void {
    name.map((name) => this.scriptLoader.removeOneScript(name));
  }

  public removeAllStyles(): void {
    this.stylesLoader.allRemoveStyles();
  }

  public removeAllScripts(): void {
    this.scriptLoader.deleteAllScript();
  }
}
